import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';

interface SettingsCustomPropertyTagsCellsTdDefinitionActionsSignature {
  Args: {
    cellData: {
      onDelete: () => void;
      onEdit: () => void;
    };
  };
  Element: HTMLTableCellElement;
}

const SettingsCustomPropertyTagsCellsTdDefinitionActions: TOC<SettingsCustomPropertyTagsCellsTdDefinitionActionsSignature> =
  <template>
    <div class="flex items-center justify-end gap-100">
      <PrismButton
        @buttonType="ghost"
        @icon="edit-pencil"
        @onClick={{@cellData.onEdit}}
        @size="small"
        data-test-button="edit-definition"
      />
      <PrismButton
        @buttonType="ghost"
        @icon="bin"
        @onClick={{@cellData.onDelete}}
        @size="small"
        data-test-button="delete-definition"
      />
    </div>
  </template>;

export default SettingsCustomPropertyTagsCellsTdDefinitionActions;
